import { createSlice } from "@reduxjs/toolkit";

const UpdateShippingAddressSlice = createSlice({
    name: 'updateShippingAddress',
    initialState: {
        loading: false,
        UpdateShippingAddressResponse: null,
        error: null,
        success: false
    },
    reducers: {
        UpdateShippingAddressRequest(state) {
            state.loading = true;
            state.error = null;
        },
        UpdateShippingAddressSuccess(state, action) {
            state.loading = false;
            state.success = true
            state.UpdateShippingAddressResponse = action.payload;
        },
        UpdateShippingAddressFailure(state, action) {
            state.loading = false;
            state.success = false;
            state.error = action.message;
        },
        UpdateShippingAddressReset(state) {
            state.loading = false;
            state.success = false
            state.error = null;
            state.UpdateShippingAddressResponse = null;
        }
    }
});

export const {
    UpdateShippingAddressRequest,
    UpdateShippingAddressSuccess,
    UpdateShippingAddressFailure,
    UpdateShippingAddressReset
} = UpdateShippingAddressSlice.actions;

export default UpdateShippingAddressSlice.reducer;